import { render, staticRenderFns } from "./DetailedAccountList.vue?vue&type=template&id=979ed78c&scoped=true"
import script from "./DetailedAccountList.vue?vue&type=script&lang=js"
export * from "./DetailedAccountList.vue?vue&type=script&lang=js"
import style0 from "./DetailedAccountList.vue?vue&type=style&index=0&id=979ed78c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979ed78c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979ed78c')) {
      api.createRecord('979ed78c', component.options)
    } else {
      api.reload('979ed78c', component.options)
    }
    module.hot.accept("./DetailedAccountList.vue?vue&type=template&id=979ed78c&scoped=true", function () {
      api.rerender('979ed78c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/gledger/DetailedAccountList.vue"
export default component.exports